export const fmtWhen = (iso, opts = {}) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", ...opts });
};

export const fmtShift = (s) => (s ? `${fmtWhen(s.start)} → ${fmtWhen(s.end, { weekday: undefined, month: undefined, day: undefined })}` : "—");

export const STATUS_LABEL = {
  pending_coworker: "Waiting on coworker",
  pending_supervisor: "Waiting on supervisor",
  approved: "Approved",
  declined: "Declined by coworker",
  rejected: "Not approved",
  cancelled: "Cancelled",
};

export const STATUS_TONE = {
  pending_coworker: "bg-sky-500/10 text-sky-700 dark:text-sky-300",
  pending_supervisor: "bg-amber-500/15 text-amber-700 dark:text-amber-300",
  approved: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300",
  declined: "bg-zinc-200 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-400",
  rejected: "bg-rose-500/10 text-rose-700 dark:text-rose-300",
  cancelled: "bg-zinc-200 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-400",
};
